/**
 * The terms of use shown in the welcome dialog and under Settings → About. Bump TERMS_VERSION
 * when they change: everyone is asked to agree again.
 */
export const TERMS_VERSION = 1;
export const TERMS_UPDATED = '7 October 2026';

export interface TermsSection {
  title: string;
  body: string;
}

export const TERMS: readonly TermsSection[] = [
  {
    title: 'Free for personal use',
    body: 'You may use Glowtrope free of charge for personal, noncommercial purposes: at home, at parties with friends, for hobby projects, study and experiments. Charities, schools, public research and government bodies may also use it free of charge.',
  },
  {
    title: 'Commercial use needs a license',
    body: 'Any commercial use needs a paid license. That includes visuals for a paid gig, club, venue, event, stream or video, and use inside a business. Copying or reusing any part of Glowtrope (its code, shaders, presets or other content) in a commercial product or service also needs a license. Contact mark@milhouse.family.',
  },
  {
    title: 'What you may not do',
    body: 'Don’t sell, rent or redistribute Glowtrope or any part of it, or remove its copyright notices, without written permission. Glowtrope is not open source: being able to see its code doesn’t give you the right to reuse it.',
  },
  {
    title: 'Flashing lights',
    body: 'Glowtrope shows bright, fast-changing and flashing images that can trigger seizures in people with photosensitive epilepsy, and discomfort in others. Photosensitivity-safe mode limits flashing but can’t guarantee safety. If you or your audience may be affected, keep it on, and stop at once if anyone feels unwell. You are responsible for showing it safely to an audience.',
  },
  {
    title: 'Your music and privacy',
    body: 'Everything runs in your browser. Your audio, files and settings stay on your device and are never uploaded. There is no account and no tracking. You are responsible for having the right to play and display the music and content you use with it.',
  },
  {
    title: 'No warranty',
    body: 'Glowtrope is provided “as is”, without any warranty. As far as the law allows, its author isn’t liable for any loss or damage from using it, including a show that doesn’t go as planned.',
  },
  {
    title: 'Ownership and changes',
    body: 'Glowtrope is © 2026 Mark Milhouse. All rights not granted here are reserved. These terms may change; if they do, you’ll be asked to agree again before you carry on using it.',
  },
];
